import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Separator',
  props: {
        colour: {
            type: String,
            default: null
        }
    },
  setup(__props) {

    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-pl-2 tw-border tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b-1", __props.colour?? 'tw-border-[#0000001f]'])
  }, null, 2))
}
}

})